export const getFullDaysByTimestamp = (timestamp: number): number => {
  return Math.floor(timestamp / 86400)
}
